import cs from './index.module.scss';
import { FormattedMessage } from "react-intl";
import CommonModal from '../commonModal';
import { useStore } from '../../../models';
import { Button } from 'antd';
import { observer } from "mobx-react-lite";
import { Hooks, Util, Platform } from "@xt/xtbase";

const { useDocumentWidth, useTranslation } = Hooks;

const XtMessage = () => {
  const { message, consl } = useStore();
  const t = useTranslation();
  const domeWidth = (useDocumentWidth() ?? 0) > 768
  const isNoPhone = message.tip === "COSMOS_1044" || message.tip === "broker.bindPhoneFirst";

  const closeMessage = () => {
    message.setMessage('');
    message.setMessageModalVisible(false);
    if (message.mcSet.has('COSMOS_1012') && !Object.keys(consl.databoardOverview).length) {
      window.location.href = Platform.isInApp() ? Util.getXTUrl('/affiliate') : Util.getUrl('/affiliate');
    }
    message.clearMcSet();
  };

  const goVerifyPhone = () => {
    message.setMessage('');
    message.setMessageModalVisible(false);
    message.clearMcSet();
    window.location.href = Util.getUrl("/accounts/user/mobile");
  };

  return (
      <CommonModal
        closable={false}
        isShowModal={message.messageModalVisible && message.tip}
        width={domeWidth ? 400 : 280}
        zIndex={1299}
      >
        <div className='XtMessage'>
          <div className='tip'>
            {message.tip && t(message.tip, message.tipMa)}
          </div>
          <div className={`${cs.globalKnowBtn}${isNoPhone ? ` ${cs.withVerify}` : ""}`}>
            {isNoPhone ? (
              <Button className={cs.knowBtn} onClick={closeMessage}>
                <FormattedMessage id={'message.know'} />
              </Button>
            ) : (
              <Button type="primary" onClick={closeMessage}>
                <FormattedMessage id={'message.know'} />
              </Button>
            )}
            {isNoPhone ? (
              <Button type="primary" className={cs.verifyBtn} onClick={goVerifyPhone}>
                {t("broker.verifyPhone")}
              </Button>
            ) : null}
          </div>
        </div>
      </CommonModal>
  );
};

export default observer(XtMessage);
